import React from 'react';
import { useSelector } from 'react-redux';
import Locale from '@active/react-utils/i18n/Locale';
import MultiPaymentMethods from './components/MultiPaymentMethods';
import { usePaymentValidateAndSubmit } from '../../../shared/utils/customizedHooks';

const MultiPayment = ({
  combineErrorCallback,
}) => {
  const {
    widgetNameSpace,
    paymentMethodsConfig: {
      title,
    } = {},
  } = useSelector(state => state.propsData);

  usePaymentValidateAndSubmit(widgetNameSpace);

  return (
    <div className='multi-payment'>
      <div className='payment-option-title'>{title ?? <Locale id='checkout.lib.components.text.refundOption'/>}</div>
      <MultiPaymentMethods combineErrorCallback={combineErrorCallback} />
    </div>
  );
};

export default MultiPayment;
